
import Component from "vue-class-component";
import Vue from "vue";
import TruckModule from "@/store/modules/truck";
import { getModule } from "vuex-module-decorators";
import notifications from "../lib/notifications";
import { GenerateImportTruckPreviewResponse, SaveTruckImportResponse, TruckImportErrorResource } from "../models/api/trucks/importTrucks";
import Select from "@/components/form/Select.vue";
import { formatDate, formatAddress, formatBool } from "../utils";
import { Address, OrderParty } from "@/models/api/orders/get";
import { AccountModule } from "@/store/modules";

const truckModuleState = getModule(TruckModule);
const accountModuleState = getModule(AccountModule);

@Component({
  components: {
    Select,
  },
})
export default class ImportTrucks extends Vue {
  uploading: boolean = false;
  saving: boolean = false;
  loading: boolean = true;
  file: any = null;
  response: GenerateImportTruckPreviewResponse = null;
  saveResponse: SaveTruckImportResponse = null;
  facilityCode: string = null;
  format: string = null;
  showWarnings: boolean = false;
  supportedFormats: any = [];

  async created() {
    try {
      const response = await truckModuleState.getImportTruckFormats();
      this.supportedFormats = response.map(x => ({ label: x.description, value: x.format }));
      this.facilityCode = accountModuleState.truckImportFacilityCodeUserSettings && accountModuleState.truckImportFacilityCodeUserSettings.length > 0 ? 
                          accountModuleState.truckImportFacilityCodeUserSettings[0] : null

      this.format = accountModuleState.truckImportFormatUserSettings && accountModuleState.truckImportFormatUserSettings.length > 0 ? 
                          accountModuleState.truckImportFormatUserSettings[0] : null

    } catch (ex) {
      notifications.error("Import Formats", "Failed to load import format list", ex);
    }
  }

  goBack() {
    this.$router.back();
  }

  async uploadFile() {
    this.uploading = true;

    try {
      this.response = await truckModuleState.generateImportTruckPreview({
        file: this.file,
        facilityCode: this.facilityCode,
        format: this.format,
      });

      accountModuleState.updateUserSettings({ settingName: "truckImportFormat", values: [ this.format ] })
      accountModuleState.updateUserSettings({ settingName: "truckImportFacilityCode", values: [ this.facilityCode ] })

      if(this.response.success && (!this.response.trucks || this.response.trucks.length == 0 ))
      {
        notifications.error("Truck Import", "No trucks found in import file.");
        this.response = null;
      }
    } catch (ex) {
      notifications.error("Truck Import", "Failed to generate preview", ex);
    }

    this.uploading = false;
  }

  resetImport() {
    this.response = null;
    this.file = null;
    this.saveResponse = null;      
    
    this.facilityCode = accountModuleState.truckImportFacilityCodeUserSettings && accountModuleState.truckImportFacilityCodeUserSettings.length > 0 ? 
                        accountModuleState.truckImportFacilityCodeUserSettings[0] : null

    this.format = accountModuleState.truckImportFormatUserSettings && accountModuleState.truckImportFormatUserSettings.length > 0 ? 
                        accountModuleState.truckImportFormatUserSettings[0] : null
  }

  formatDate(date: Date): string {
    return formatDate(date, "YYYY-MM-DD");
  }

  formatZip3s(zip3s: Array<string>): string {
    if(zip3s)
      return zip3s.join(",");
    return ""
  }

  formatAddress(address: Address): string {
    return formatAddress(address);
  }

  formatBool(bool: boolean): string {
    return formatBool(bool);
  }

  

  get importHasErrors(): boolean {
    return this.response && this.response.errors && this.response.errors.length > 0;
  }

  set importHasErrors(val: boolean) {
    if (!val) {
      this.response = null;
    }
  }

  get importHasWarnings(): boolean {
    return this.response && this.response.warnings && this.response.warnings.length > 0;
  }

  get saveHasErrors(): boolean {
    return this.saveResponse && this.saveResponse.errors && this.saveResponse.errors.length > 0;
  }

  set saveHasErrors(val: boolean) {
    if (!val) {
      this.saveResponse = null;
    }
  }

  get importCanBeSaved(): boolean {
    return this.response && !this.importHasErrors;
  }

  hideImportErrorModal() {
    this.$bvModal.hide("importErrorModal");
  }

  hideImportWarningModal() {
    this.$bvModal.hide("importWarningModal");
  }

  hideSaveErrorModal() {
    this.$bvModal.hide("saveErrorModal");
  }

  viewWarnings() {
    this.showWarnings = true;
  }

  async saveImport() {
    this.saving = true;
    try {
      this.saveResponse = await truckModuleState.saveTruckImport(
        this.response
      );

      if (this.saveResponse.success) {
        notifications.success(
          "Truck Import",
          "Imported trucks successfully saved"
        );
        this.saveResponse = null;
        this.$router.push({ path: "/trucks" });
      }
    } catch (ex) {
      notifications.error("Truck Import", "Failed to import trucks", ex);
    }

    this.saving = false;
  }
  get canSubmitPreview() {
    return this.format && this.facilityCode;
  }

  downloadErrorCSVData(errors: TruckImportErrorResource[]) {
    var csv = "location,message\n";
    errors.forEach((error) => {
      csv += '"' + error.location.replace('"', '""') + '","' + error.message.replace('"', '""') + '"\n';
    });
 
    const anchor = document.createElement('a');
    anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    anchor.target = '_blank';
    anchor.download = 'export-exceptions.csv';
    anchor.click();
  } 
}
